import React from 'react';
import Form from './Components/Form';
import './App.css';



function App() {
  return (
    
    <div className="App">
    
      <header className="App-header">
      </header>
      <Form />
    
</div>
    
  );
}

export default App;
